// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2j2uF","footer":"ModalCreateQualiphyProcedure_footer__23vx1","additionData":"ModalCreateQualiphyProcedure_additionData__1Sp_F"};